import { SectionHeading } from './SectionHeading';
import { ServiceCard } from './ServiceCard';
import { Typography } from './Typography';
import { DataVisual } from './DataVisual';
import { Button } from './Button';
import { services } from '../content/site';
import styles from './ServicesSection.module.css';
export function ServicesSection({ expanded = false }: { expanded?: boolean }) {
  return (
    <section className={styles.section} id="services">
      <SectionHeading eyebrow="Услуги Audit Vector" title="Точность, на которую можно опереться" />
      <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
        <ServiceCard title={services[0].title} description={services[0].desc} kind="report" />
        <ServiceCard title={services[1].title} description={services[1].desc} kind="inventory" />
        {expanded && (
          <ServiceCard title={services[2].title} description={services[2].desc} kind="assets" />
        )}
        {expanded && (
          <ServiceCard title={services[3].title} description={services[3].desc} kind="report" />
        )}
      </div>
      <article className={styles.wide}>
        <div className={styles.copy}>
          <Typography as="h3" variant="title">
            От проверки активов до понятного итогового отчёта
          </Typography>
          <Typography tone="muted">
            Проверяем наличие, состояние и учётную стоимость основных средств. Готовим
            структурированные материалы с рекомендациями по устранению расхождений и оптимизации
            учёта.
          </Typography>
          <div className={styles.bottom}>
            <Button href={expanded ? '/contact/' : '/services/'}>
              {expanded ? 'Обсудить задачу' : 'Все услуги'}
            </Button>
            <Typography variant="small" tone="muted">
              Промышленные и государственные заказчики
            </Typography>
          </div>
        </div>
        <DataVisual kind="analysis" />
      </article>
    </section>
  );
}
